module.exports = __webpack_public_path__ + "img/05.20097c02.png";